import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DeviceStatus from '../../../../constants/deviceStatus';
import styled from 'styled-components';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import { getDeviceStatusColor } from 'modules/HealthCheck/helpers';
import { Spinner } from '@purpurds/purpur/spinner';
const HealthCheckStatusContainerItem = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
`;
const StatusIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
`;
const StyledIcon = styled(Icon) `
  svg {
    fill: ${({ $status }) => getDeviceStatusColor($status)};
  }
`;
export const StatusCheck = ({ checkTitle, isFetching, deviceStatus }) => (_jsxs(HealthCheckStatusContainerItem, { children: [_jsx(StatusIconWrapper, { children: isFetching ? (_jsx(Spinner, { size: 'xs' })) : deviceStatus === DeviceStatus.OK ||
                deviceStatus === DeviceStatus.NEUTRAL ? (_jsx(StyledIcon, { svg: icons.checkCircleFilled, "$status": deviceStatus, size: 'md' })) : (_jsx(StyledIcon, { svg: icons.alertFilled, "$status": deviceStatus, size: 'md' })) }), checkTitle] }));
